// Containers
import Full from '../containers/Full';
import Empty from '../containers/Empty';
import Customers from './views/Customers';
import Dashboard from './views/Dashboard';
import {Roles} from "../admin_area/services/permissionManager";
import CustomerDevices from "./views/CustomerDevices.vue";
import {AclsEnum} from "../js/enums";
import MdmPasswords from "./views/MdmPasswords.vue";

// Views
const Customer = () => import('./views/Customer');
const CustomerLicenses = () => import('./views/CustomerLicenses');
const CustomerATS3Licenses = () => import('./views/CustomerATS3Licenses');
const CustomerATSLicenses = () => import('./views/CustomerATSLicenses');
const CustomerStore = () => import('./views/CustomerStore');
const CustomerForm = () => import("./views/CustomerForm");
const CustomerStoreForm = () => import("./views/CustomerStoreForm");
const CustomerPos = () => import("./views/CustomerPos.vue");
const DemoAccount = () => import('./views/DemoAccount');
const QRCodeInvitation = () => import('./views/QRCodeInvitation');
const Devices = () => import('./views/Devices');
const Device = () => import('./views/Device');
const AddDevice = () => import('./views/AddDevice');
const Updates = () => import('./views/Updates');
const PurchaseUpdates = () => import('./views/PurchaseUpdates');
const Orders = () => import('./views/Orders');
const Order = () => import('./views/Order');
const OrderRequests = () => import('./views/OrderRequests');
const OrderRequest = () => import('./views/OrderRequest');
const DgfeInitializations = () => import('./views/DgfeInitializations');
const DgfeInitialization = () => import('./views/DgfeInitialization');
const Settings = () => import('./views/Settings');
const DistributorOrders = () => import('./views/DistributorOrders');
const DistributorAccounts = () => import('./views/DistributorAccounts');
const DistributorAccount = () => import('./views/DistributorAccount');
const DistributorTransactionsContainer = () => import('./views/DistributorTransactionsContainer');
const DistributorTransactionsRchPay = () => import('./views/DistributorTransactionsRCHPay');
const DistributorTransactionsSumUp = () => import('./views/DistributorTransactionsSumUp');
const DistributorAddAccount = () => import('./views/DistributorAddAccount');
const AddDemoCustomer = () => import('./views/AddDemoCustomer');
const Gcs = () => import('./views/Gcs');
const Msg = () => import('./views/Msg.vue');
const Company = () => import('./views/Company');
const Prog = () => import('./components/Prog');
const Rental = () => import('./views/Rental');
const OnDemandSettings = () => import('./views/OnDemandSettings');
const OnDemandMassiveList = () => import('./views/OnDemandMassiveList');
const Scheduled = () => import('./views/Scheduled');
const Labels = () => import('./views/Labels');
const DownloadArea = () => import('./views/DownloadArea');
const AtsUpdate = () => import('./views/AtsUpdate');
const Licenses = () => import('./views/Licenses');
const AtsLicense = () => import('./views/AtsLicense');
const AddATSLicense = () => import('./views/AddATSLicense');
const Ats3License = () => import('./views/Ats3License');
const AddATS3License = () => import('./views/AddATS3License');
const AnydeskLicense = () => import('./views/AnydeskLicense');
const AddAnydeskLicense = () => import('./views/AddAnydeskLicense');
const GenericDownload = () => import('./views/GenericDownload');
const Rebates = () => import('./views/Rebates');
const PayBoxActivationsContainer = () => import('./views/PayBoxActivationsContainer');
const RchPayActivations = () => import('./views/RchPayActivations');
const SumUpActivations = () => import('./views/SumUpActivations');
const SatispayActivations = () => import('./views/SatispayActivations');
const CLinkLicense = () => import('./views/CLinkLicense');
const AddCLinkLicense = () => import('./views/AddCLinkLicense');
const PosSettings  = () => import('./views/pos_settings/PosSettings');
const PaymentSettings  = () => import('./views/pos_settings/PaymentSettings');;
const PaymentSettingsDetail  = () => import('./views/pos_settings/PaymentSettingsDetail');
const VatSettings  = () => import('./views/pos_settings/VatSettings');
const VirtualPrintersSettings  = () => import('./views/pos_settings/VirtualPrintersSettings');
//const ProductionUnitsSettings = () => import('./views/pos_settings/ProductionUnitsSettings')
//const ProductionUnitsSettingsDetail = () => import('./views/pos_settings/ProductionUnitsSettingsDetail')
const OperatorSettings  = () => import('./views/pos_settings/OperatorSettings');
const OperatorSettingsDetail  = () => import('./views/pos_settings/OperatorSettingsDetail');
const StockforshopLicense = () => import('./views/StockforshopLicense.vue');
const AddStockforshopLicense = () => import('./views/AddStockforshopLicense.vue');
const SmartControlWallet = () => import('./views/SmartControlWallet.vue');
const MaintenanceContractPackagePurchased = () => import('./views/MaintenanceContractPackagePurchased.vue');
const Users = () => import('./views/Users');
const User = () => import('./views/User');
const XToolLicense = () => import('./views/XToolLicense');
const AddXToolLicense = () => import('./views/AddXToolLicense');
const Registration = () => import('./views/Registration');
const Appalto = () => import('./views/Appalto');


const routes = (lang, home) => [
  {
    path: `/${lang}/dealer`,
    name: 'Home',
    meta: { label: 'Home', icon: null },
    redirect: { name: `${home}` },
    component: Full,
    children: [
        {
          path: 'registration',
          name: 'Registration',
          meta: {
            label: 'Dealer Registration',
            previous: 'Home',
            icon: null,
            hiddenFor: ['has_distributor', 'distributor']
          },
          component: Registration
        },
        {
            path: 'gcs',
            name: 'Gcs',
            meta: {
                label: 'General Conditions of Sale',
                previous: 'Home',
                icon: null,
                hiddenFor: ['gcs_confirmed']
            },
            component: Gcs
        },
        {
            path: 'msg',
            name: 'Msg',
            meta: {
                label: 'Message',
                previous: 'Home',
                icon: null,
                hiddenFor: ['active_account']
            },
            props: true,
            component: Msg
        },
        // {
        //     path: 'garcon',
        //     name: 'Garcon',
        //     meta: { label: 'Garcon', previous: 'Home', icon: null },
        //     component: Garcon
        // },
        // {
        //     path: 'waiter',
        //     name: 'Waiter',
        //     meta: { label: 'Waiter', previous: 'Home', icon: null },
        //     component: Garcon
        // },
        {
          path: 'dashboard',
          name: 'Dashboard',
          meta: {
            label: 'Dashboard',
            previous: 'Home',
            icon: null,
            allowedFor: [AclsEnum.CAN_ACCESS_DEALER_DASHBOARD],
            hiddenFor: ['unknown','gcs_unchecked','no_active_account']
          },
          component: Dashboard
        },
        {
            path: 'customers',
            name: 'Customers',
            meta: {
                label: 'Customers',
                previous: 'Home',
                icon: null,
                hiddenFor: ['gcs_unchecked','no_active_account']
            },
            component: Customers
        },
        {
            path: 'customer/new',
            name: 'Create Customer',
            component: CustomerForm,
            meta: {
                label: 'Create Customer',
                previous: 'Customers',
                icon: null,
                hiddenFor: ['gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'customer/demo',
            name: 'AccountDemoContainer',
            redirect: { name: 'Account demo' },
            component: Empty,
            children: [
                {
                    path: '',
                    name: 'Account demo',
                    component: DemoAccount,
                    meta: {
                        label: 'Account demo XStore',
                        previous: 'Home',
                        icon: null,
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account', 'not_has_demo']
                    },
                },
                {
                    path: 'new',
                    name: 'AddDemoCustomer',
                    meta: {
                        label: 'Add XStore demo account',
                        icon: null,
                        previous: 'Customers',
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['gcs_unchecked','no_active_account', 'has_demo']
                    },
                    component: AddDemoCustomer
                },
                {
                    path: 'license/:license_id',
                    name: 'Demo License details',
                    component: AtsLicense,
                    meta: {
                        label: 'License details',
                        previous: 'Account demo',
                        icon: null,
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account','not_has_demo']
                    }
                },
                {
                    path: 'license/:license_id',
                    name: 'Demo ATS3 License details',
                    component: Ats3License,
                    meta: {
                        label: 'License details',
                        previous: 'Account demo',
                        icon: null,
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account','not_has_demo']
                    }
                },
                {
                    path: ':customer_id/pos-settings',
                    name: 'PosSettingsContainer',
                    redirect: { name: 'Pos Settings Demo' },
                    meta: {
                        label: 'Pos settings',
                        icon: null
                    },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Pos Settings Demo',
                            meta: { previous: 'Account demo', label: 'Pos settings', icon: null},
                            props: {
                                demo: true
                            },
                            component: PosSettings,
                        },
                        {
                            path: 'payments',
                            name: 'Payment Settings Demo',
                            meta: { label: 'Payment settings', icon: null, previous: 'Pos Settings Demo'},
                            props: {
                                demo: true
                            },
                            component: PaymentSettings
                        },
                        {
                            path: 'payments/:payment_id?',
                            name: 'Payment Settings Details Demo',
                            meta: { label: 'Payment details', icon: null, previous: 'Payment Settings Demo'},
                            props: true,
                            component: PaymentSettingsDetail
                        },
                        {
                            path: 'vats',
                            name: 'Vat Settings Demo',
                            meta: { label: 'VAT Groups settings', icon: null, previous: 'Pos Settings Demo'},
                            props: true,
                            component: VatSettings
                        },
                        // {
                        //     path: 'production_units',
                        //     name: 'Production Units Settings Demo',
                        //     meta: { label: 'Production units', icon: null, previous: 'Pos Settings Demo'},
                        //     props: {
                        //         demo: true
                        //     },
                        //     component: ProductionUnitsSettings
                        // },
                        // {
                        //     path: 'production_units/:production_unit_id?',
                        //     name: 'Production Units Settings Details Demo',
                        //     meta: { label: 'Production units details', icon: null, previous: 'Production Units Settings Demo'},
                        //     props: {
                        //         demo: true
                        //     },
                        //     component: ProductionUnitsSettingsDetail
                        // },
                        {
                            path: 'operators',
                            name: 'Operator Settings Demo',
                            meta: { label: 'Operators', icon: null, previous: 'Pos Settings Demo'},
                            props: {
                                demo: true
                            },
                            component: OperatorSettings
                        },
                        {
                            path: 'operators/:operator_id?',
                            name: 'Operator Settings Details Demo',
                            meta: { label: 'Operator settings details', icon: null, previous: 'Operator Settings Demo'},
                            props: {
                                demo: true
                            },
                            component: OperatorSettingsDetail
                        },
                        {
                            path: 'printers',
                            name: 'Printers Settings Demo',
                            meta: { label: 'Printers', icon: null, previous: 'Pos Settings Demo', disabledForLicenseCode: ['personal', 'premium']  },
                            props: true,
                            component: VirtualPrintersSettings
                        },
                    ]
                }
            ]
        },
        {
            path: 'customer/:customer_id',
            name: 'Customer',
            component: Empty,
            children: [
                {
                    path: '',
                    name: 'Customer',
                    component: Customer,
                    meta: {
                        label: 'Customer',
                        icon: null,
                        previous: 'Customers',
                        hiddenFor: ['gcs_unchecked','no_active_account']
                    },
                },
                {
                    path: 'licenses',
                    name: 'Customer licenses',
                    meta: {
                        label: 'Customer licenses',
                        icon: null,
                        previous: 'Customers',
                        hiddenFor: ['gcs_unchecked','no_active_account']
                    },
                    component: CustomerLicenses
                },
                {
                    path: 'ats3-licenses',
                    name: 'Customer ATS3 licenses',
                    meta: {
                        label: 'Customer ATS3 licenses',
                        icon: null,
                        previous: 'Customer',
                        hiddenFor: ['gcs_unchecked','no_active_account']
                    },
                    component: CustomerATS3Licenses
                },
                {
                    path: 'ats-licenses',
                    name: 'Customer ATS licenses',
                    meta: {
                        label: 'Customer ATS licenses',
                        icon: null,
                        previous: 'Customer',
                        hiddenFor: ['gcs_unchecked','no_active_account']
                    },
                    component: CustomerATSLicenses
                },
                {
                  path: 'devices',
                  name: 'Customer devices',
                  meta: {
                    label: 'Customer devices',
                    icon: null,
                    previous: 'Customer',
                    hiddenFor: ['gcs_unchecked','no_active_account']
                  },
                  component: CustomerDevices
                },
                {
                    path: 'store/:store_id',
                    name: 'Customer Store',
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Customer Store',
                            component: CustomerStore,
                            meta: {
                                label: 'Store',
                                previous: 'Customer',
                                icon: null,
                                hiddenFor: ['gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'edit',
                            name: 'Edit Store',
                            component: CustomerStoreForm,
                            meta: {
                                label: 'Edit Store',
                                previous: 'Customer Store',
                                icon: null,
                                hiddenFor: ['gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'pos/:pos_id',
                            name: 'Customer Pos',
                            component: CustomerPos,
                            meta: {
                                label: 'POS',
                                previous: 'Customer Store',
                                icon: null,
                                hiddenFor: ['gcs_unchecked','no_active_account']
                            }
                        },
                    ]
                },
                {
                    path: 'store/new',
                    name: 'Add Store',
                    component: CustomerStoreForm,
                    meta: {
                        label: 'Add Store',
                        previous: 'Customer',
                        icon: null,
                        hiddenFor: ['gcs_unchecked','no_active_account']
                    }
                },
                {
                    path: 'pos-settings',
                    name: 'Pos Settings Container',
                    meta: {
                        label: 'Pos settings',
                        icon: null
                    },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Pos Settings',
                            meta: { previous: 'Customer', label: 'Pos settings', icon: null},
                            component: PosSettings,
                        },
                        {
                            path: 'payments',
                            name: 'Payment Settings',
                            meta: { label: 'Payment settings', icon: null, previous: 'Pos Settings'},
                            props: true,
                            component: PaymentSettings
                        },
                        {
                            path: 'payments/:payment_id?',
                            name: 'Payment Settings Details',
                            meta: { label: 'Payment details', icon: null, previous: 'Payment Settings'},
                            props: true,
                            component: PaymentSettingsDetail
                        },
                        {
                            path: 'vats',
                            name: 'Vat Settings',
                            meta: { label: 'VAT Groups settings', icon: null, previous: 'Pos Settings'},
                            props: true,
                            component: VatSettings
                        },
                        // {
                        //     path: 'production_units',
                        //     name: 'Production Units Settings',
                        //     meta: { label: 'Production units', icon: null, previous: 'Pos Settings'},
                        //     props: true,
                        //     component: ProductionUnitsSettings
                        // },
                        // {
                        //     path: 'production_units/:production_unit_id?',
                        //     name: 'Production Units Settings Details',
                        //     meta: { label: 'Production units details', icon: null, previous: 'Production Units Settings'},
                        //     props: true,
                        //     component: ProductionUnitsSettingsDetail
                        // },
                        {
                            path: 'operators',
                            name: 'Operator Settings',
                            meta: { label: 'Operators', icon: null, previous: 'Pos Settings'},
                            props: true,
                            component: OperatorSettings
                        },
                        {
                            path: 'operators/:operator_id?',
                            name: 'Operator Settings Details',
                            meta: { label: 'Operator settings details', icon: null, previous: 'Operator Settings'},
                            props: true,
                            component: OperatorSettingsDetail
                        },
                        {
                            path: 'printers',
                            name: 'Printers Settings',
                            meta: { label: 'Printers', icon: null, previous: 'Pos Settings', disabledForLicenseCode: ['personal', 'premium']  },
                            props: true,
                            component: VirtualPrintersSettings
                        },
                    ]
                }
            ]
        },
        {
            path: 'qr-code',
            name: 'QRCodeInvitation',
            meta: {
                label: 'QR code invitation',
                previous: 'Home',
                icon: null,
                hiddenFor: ['gcs_unchecked','no_active_account']
            },
            component: QRCodeInvitation
        },
        {
            path: 'smart-control-wallet',
            name: 'WalletContainer',
            redirect: {name: 'Smart control wallet'},
            component: Empty,
            children: [

                {
                    path: '',
                    name: 'Smart control wallet',
                    component: SmartControlWallet,
                    meta: {
                        label: 'Smart control wallet',
                        previous: 'Home',
                        icon: null,
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account','abroad','prepayment']
                    }
                },
                {
                    path: 'sc-package-purchased/:package_id',
                    name: 'Maintenance contract package purchased details',
                    component: MaintenanceContractPackagePurchased,
                    meta: {
                        label: 'Purchased smart control package',
                        previous: 'Smart control wallet',
                        icon: null,
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account','abroad','prepayment']
                    },
                },
                {
                    path: 'sc-package-purchased/:package_id/order/:order_id',
                    name: 'Maintenance contract package purchased order',
                    component: Order,
                    meta: {
                        label: 'Order',
                        previous: 'Maintenance contract package purchased details',
                        icon: null,
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account','abroad','prepayment']
                    }
                },

            ]
        },

        {
            path: 'dgfe-initializations',
            name: 'DGFE Initializations',
            component: DgfeInitializations,
            meta: {
                label: 'DGFE Management',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'dgfe-initialization/add',
            name: 'DGFE Initialization',
            component: DgfeInitialization,
            meta: {
                label: 'DGFE Detail',
                previous: 'DGFE Initializations',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
      {
        path: 'users',
        name: 'UsersContainer',
        meta: {
          label: 'Users',
          previous: 'Home',
          icon: null ,
          allowedFor: [AclsEnum.CAN_VIEW_ANY_USERS],
        },
        redirect: { name: 'Users' },
        component: Empty,
        children: [
          {
            path: '',
            name: 'Users',
            component: Users,
            meta: {
              label: 'Users',
              previous: 'Home',
              icon: null,
            },
            props: false
          },
          {
            path: ':user_id?',
            name: 'UserContainer',
            meta: { label: 'Detail', icon: null },
            redirect: { name: 'User' },
            component: Empty,
            children: [
              {
                path: '',
                name: 'User',
                component: User,
                meta: {
                  label: 'User',
                  previous: 'Users',
                  icon: null,
                },
                props: false
              },
            ]
          },

        ]
      },
        {
            path: 'company',
            name: 'CompanyContainer',
            meta: {
                label: 'Company Data',
                previous: 'Home',
                icon: null
            },
          redirect: { name: 'Company' },
          component: Empty,
          children: [
            {
              path: '',
              name: 'Company',
              component: Company,
              meta: {
                label: 'Company',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
              }
            },
              {
                path: 'appalto',
                name: 'Firma Appalto',
                component: Appalto,
                meta: {
                  label: 'Firma Appalto',
                  previous: 'Company',
                  icon: null,
                  allowedFor: [AclsEnum.CAN_SIGN_APPALTO],
                  hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                }
              },
            ]
        },
        {
            path: 'devices',
            name: 'DevicesContainer',
            meta: {
                label: 'Manage devices',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            },
            redirect: { name: 'Manage devices' },
            component: Empty,
            children: [
                {
                    path: '',
                    name: 'Manage devices',
                    component: Devices,
                    meta: {
                        label: 'Manage devices',
                        previous: 'Home',
                        icon: null,
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                    }
                },
                {
                    path: 'add',
                    name: 'Add Device',
                    component: AddDevice,
                    meta: {
                        label: 'Add device',
                        previous: 'Manage devices',
                        icon: null,
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                    }
                },
                {
                    path: ':device_id',
                    name: 'Device detail',
                    component: Device,
                    meta: {
                        label: 'Device detail',
                        previous: 'Manage devices',
                        icon: null,
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                    }
                },
                {
                    path: ':device_id/rental',
                    name: 'Operating rental',
                    component: Rental,
                    meta: {
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account'],
                        previous: 'Device detail',
                        icon: null,
                        label: 'Operating rental'
                    }
                },
                {
                    path: ':device_id/ondemand',
                    name: 'On demand settings',
                    component: OnDemandSettings,
                    meta: {
                        allowedFor: [],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account'],
                        previous: 'Device detail',
                        icon: null,
                        label: 'On Demand update settings'
                    }
                },
                {
                    path: ':device_id/prog/:prog_id',
                    name: 'Prog',
                    component: Prog,
                    meta: {
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account'],
                        previous: 'Device detail',
                        icon: null,
                        label: 'Programmazioni'
                    }
                }
            ]
        },
        {
            path: 'ondemand-massive',
            name: 'Massive on demand settings',
            component: OnDemandMassiveList,
            meta: {
                label: 'On Demand updates',
                previous: 'Manage devices',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'updates',
            name: 'Update history',
            component: Updates,
            meta: {
                label: 'Update history',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'scheduled',
            name: 'Scheduled updates',
            component: Scheduled,
            meta: {
                label: 'Scheduled updates',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'purchase-updates',
            name: 'Purchase updates',
            component: PurchaseUpdates,
            meta: {
                label: 'Purchase updates',
                previous: 'Manage devices',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'orders',
            name: 'Orders',
            component: Orders,
            meta: {
                label: 'Orders',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'orders/:order_id',
            name: 'Order',
            component: Order,
            meta: {
                label: 'Order',
                previous: 'Orders',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'order-requests',
            name: 'Order Requests',
            component: OrderRequests,
            meta: {
                label: 'Order Requests',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account', 'no_prepayment']
            }
        },
        {
            path: 'order-requests/:order_request_id',
            name: 'Order Request',
            component: OrderRequest,
            meta: {
                label: 'Order Request',
                previous: 'Order Requests',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account', 'no_prepayment']
            }
        },
        {
            path: 'labels-management',
            name: 'Labels management',
            component: Labels,
            meta: {
                label: 'Labels management',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'rebates',
            name: 'Rebates',
            component: Rebates,
            meta: {
                label: 'Rebates',
                previous: 'Home',
                icon: null,
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'settings',
            name: 'Settings',
            component: Settings,
            meta: {
                label: 'Settings',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'distributor-orders',
            name: 'Distributor Orders',
            component: DistributorOrders,
            meta: {
                label: 'Order history',
                previous: 'Home',
                icon: null,
                allowedFor: ['distributor', 'mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'distributor-orders/:order_id',
            name: 'Distributor Order',
            component: Order,
            meta: {
                label: 'Order',
                previous: 'Distributor Orders',
                icon: null,
                allowedFor: ['distributor', 'mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'distributor-accounts',
            name: 'Distributor Accounts',
            component: DistributorAccounts,
            meta: {
                label: 'Account',
                previous: 'Home',
                icon: null,
                allowedFor: ['distributor', 'mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'distributor-accounts/add',
            name: 'Add dealer',
            component: DistributorAddAccount,
            meta: {
                label: 'Add dealer',
                previous: 'Distributor Accounts',
                icon: null,
                allowedFor: ['distributor', 'mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'distributor-accounts/:invitation_id',
            name: 'Distributor Account',
            component: DistributorAccount,
            meta: {
                label: 'Account',
                previous: 'Distributor Accounts',
                icon: null,
                allowedFor: ['distributor', 'mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'distributor-transactions',
            name: 'Distributor Transactions',
            component: DistributorTransactionsContainer,
            redirect: {name: 'Distributor RCH Pay Transactions'},
            children: [
              {
                path: 'rchpay',
                name: 'Distributor RCH Pay Transactions',
                component: DistributorTransactionsRchPay,
                meta: {
                  label: 'Distributor RCH Pay transactions',
                  previous: 'Home',
                  icon: null,
                  allowedFor: ['distributor', 'mkt_it'],
                  hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                }
              },
              {
                path: 'sumup',
                name: 'Distributor SumUp Transactions',
                component: DistributorTransactionsSumUp,
                meta: {
                  label: 'Distributor SumUp transactions',
                  previous: 'Home',
                  icon: null,
                  allowedFor: ['distributor', 'mkt_it', 'mkt_de', 'mkt_ch'],
                  hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                }
              }
            ]
        },
        {
            path: 'download-area',
            name: 'Download area',
            component: DownloadArea,
            meta: {
                label: 'Download area',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account','com_lock']
            }
        },
        {
            path: 'download-area/ats/:downloadable_file_id',
            name: 'Download area ats file',
            component: AtsUpdate,
            meta: {
                label: 'File details',
                previous: 'Download area',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account','com_lock']
            }
        },
        {
            path: 'download-area/generic/:download_id',
            name: 'Download area generic file',
            component: GenericDownload,
            meta: {
                label: 'File details',
                previous: 'Download area',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account','com_lock']
            }
        },
        {
            path: 'licenses',
            name: 'Licenses',
            component: Empty,
            meta: {
                label: 'Licenses',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it', 'abroad'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            },
            redirect: { name: 'ATS Licenses and modules' },
            children: [
                {
                    path: 'ats',
                    name: 'ATSLicensesContainer',
                    redirect: { name: 'ATS Licenses and modules' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'ATS Licenses and modules',
                            component: Licenses,
                            meta: {
                                label: 'ATS Licenses and modules',
                                previous: 'Home',
                                icon: null,
                                allowedFor: ['mkt_it', 'abroad'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            },
                            props: {
                                'activeTab': 0
                            }
                        },
                        {
                            path: 'add',
                            name: 'Purchase license',
                            component: AddATSLicense,
                            meta: {
                                label: 'Purchase',
                                previous: 'ATS Licenses and modules',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'license/:license_id',
                            name: 'License details',
                            component: AtsLicense,
                            meta: {
                                label: 'License details',
                                previous: 'ATS Licenses and modules',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'license/:license_id/order/:order_id',
                            name: 'License order',
                            component: Order,
                            meta: {
                                label: 'Order',
                                previous: 'License details',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'license/:license_id/customer/:customer_id',
                            name: 'License customer',
                            meta: {
                                label: 'Customer',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                previous: 'License details',
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            },
                            component: Customer
                        },
                        {
                            path: 'module/:license_id',
                            name: 'Module details',
                            component: AtsLicense,
                            meta: {
                                label: 'Module details',
                                previous: 'ATS Licenses and modules',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'module/:license_id/order/:order_id',
                            name: 'Module order',
                            component: Order,
                            meta: {
                                label: 'Order',
                                previous: 'Module details',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'module/:license_id/customer/:customer_id',
                            name: 'Module customer',
                            meta: {
                                label: 'Customer',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                previous: 'Module details',
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            },
                            component: Customer
                        },
                    ]
                },
                {
                    path: 'ats3',
                    name: 'ATS3LicensesContainer',
                    redirect: { name: 'ATS3 Licenses' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'ATS3 licenses',
                            component: Licenses,
                            meta: {
                                label: 'ATS3 Licenses',
                                previous: 'Home',
                                icon: null,
                                allowedFor: ['mkt_it', 'abroad'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']

                            },
                            props: {
                                'activeTab': 5
                            }
                        },
                        {
                            path: 'add',
                            name: 'Purchase ATS3 license',
                            component: AddATS3License,
                            meta: {
                                label: 'Purchase',
                                previous: 'ATS3 licenses',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'license/:license_id',
                            name: 'ATS3 license details',
                            component: Ats3License,
                            meta: {
                                label: 'License details',
                                previous: 'ATS3 licenses',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'license/:license_id/edit',
                            name: 'Edit ATS3 license',
                            component: AddATS3License,
                            meta: {
                                label: 'Edit',
                                previous:'ATS3 license details',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'license/:license_id/order/:order_id',
                            name: 'ATS3 license order',
                            component: Order,
                            meta: {
                                label: 'Order',
                                previous: 'ATS3 license details',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'license/:license_id/customer/:customer_id',
                            name: 'ATS3 license customer',
                            component: Customer,
                            meta: {
                                label: 'Customer',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                previous: 'ATS3 license details',
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                    ]
                },
                {
                    path: 'anydesk',
                    name: 'AnydeskLicensesContainer',
                    redirect: { name: 'Anydesk licenses' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Anydesk licenses',
                            component: Licenses,
                            meta: {
                                label: 'AnyDesk Licenses',
                                previous: 'Home',
                                icon: null,
                                allowedFor: ['mkt_it', 'abroad'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            },
                            props: {
                                'activeTab': 1
                            }
                        },
                        {
                            path: 'add',
                            name: 'Purchase anydesk license',
                            component: AddAnydeskLicense,
                            meta: {
                                label: 'Purchase',
                                previous: 'Anydesk licenses',
                                icon: null,
                                allowedFor: ['mkt_it', 'abroad'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'license/:license_id',
                            name: 'Anydesk license details',
                            component: AnydeskLicense,
                            meta: {
                                label: 'License details',
                                previous: 'Anydesk licenses',
                                icon: null,
                                allowedFor: ['mkt_it', 'abroad'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'license/:license_id/order/:order_id',
                            name: 'Anydesk license order',
                            component: Order,
                            meta: {
                                label: 'Order',
                                previous: 'Anydesk license details',
                                icon: null,
                                allowedFor: ['mkt_it', 'abroad'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                    ]
                },
                {
                    path: 'xtool',
                    name: 'XToolsLicensesContainer',
                    redirect: { name: 'XTools licenses' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'XTools licenses',
                            component: Licenses,
                            meta: {
                                label: 'XTools Licenses',
                                previous: 'Home',
                                icon: null,
                                allowedFor: ['mkt_it', 'abroad'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            },
                            props: {
                                'activeTab': 4
                            }
                        },
                        {
                            path: 'add',
                            name: 'Purchase XTools license',
                            component: AddXToolLicense,
                            meta: {
                                label: 'Purchase',
                                previous: 'XTools licenses',
                                icon: null,
                                allowedFor: ['mkt_it', 'abroad'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'license/:license_id',
                            name: 'XTools license details',
                            component: XToolLicense,
                            meta: {
                                label: 'License details',
                                previous: 'XTools licenses',
                                icon: null,
                                allowedFor: ['mkt_it', 'abroad'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'license/:license_id/order/:order_id',
                            name: 'XTools license order',
                            component: Order,
                            meta: {
                                label: 'Order',
                                previous: 'XTools license details',
                                icon: null,
                                allowedFor: ['mkt_it', 'abroad'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                    ]
                },
                {
                    path: 'c-link',
                    name: 'ClinkLicensesContainer',
                    redirect: { name: 'Clink licenses' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Clink licenses',
                            component: Licenses,
                            meta: {
                                label: 'C-Link Licenses',
                                previous: 'Home',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            },
                            props: {
                                'activeTab': 2
                            }
                        },
                        {
                            path: 'add',
                            name: 'Purchase clink license',
                            component: AddCLinkLicense,
                            meta: {
                                label: 'Purchase',
                                previous: 'Clink licenses',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'license/:license_id',
                            name: 'Clink license details',
                            component: CLinkLicense,
                            meta: {
                                label: 'License details',
                                previous: 'Clink licenses',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'license/:license_id/order/:order_id',
                            name: 'Clink license order',
                            component: Order,
                            meta: {
                                label: 'Order',
                                previous: 'Clink license details',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                            }
                        },
                    ]
                },
                {
                    path: 'stock-for-shop',
                    name: 'StockforshopLicensesContainer',
                    redirect: {name: 'Stock for shop licenses'},
                    component: Empty,
                    children: [
                        {
                            path: 'account',
                            name: 'Create stock for shop account',
                            component: Licenses,
                            meta: {
                                label: 'Stock for Shop Account',
                                previous: 'Home',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown', 'gcs_unchecked','no_active_account','abroad']
                            },
                            props: {
                                'activeTab': 3
                            }
                        },
                        {
                            path: '',
                            name: 'Stock for shop licenses',
                            component: Licenses,
                            meta: {
                                label: 'Stock for Shop Licenses',
                                previous: 'Home',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown', 'gcs_unchecked','no_active_account','abroad']
                            },
                            props: {
                                'activeTab': 3
                            }
                        },
                        {
                            path: 'add',
                            name: 'Purchase stock for shop license',
                            component: AddStockforshopLicense,
                            meta: {
                                label: 'Purchase',
                                previous: 'Stock for shop licenses',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account','abroad']
                            }
                        },
                        {
                            path: 'license/:license_id',
                            name: 'Stock for shop license details',
                            component: StockforshopLicense,
                            meta: {
                                label: 'License details',
                                previous: 'Stock for shop licenses',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account','abroad']
                            }
                        },
                        {
                            path: 'license/:license_id/order/:order_id',
                            name: 'Stock for shop license order',
                            component: Order,
                            meta: {
                                label: 'Order',
                                previous: 'Stock for shop license details',
                                icon: null,
                                allowedFor: ['mkt_it'],
                                hiddenFor: ['unknown','gcs_unchecked','no_active_account','abroad']
                            }
                        },
                    ]
                },

            ]
        },
        {
          path: 'paybox-activations',
          name: 'PayBoxActivationsContainer',
          redirect: {name: 'RCH Pay activations'},
          component: PayBoxActivationsContainer,
          children: [
            {
              path: 'rchpay',
              name: 'RCH Pay activations',
              component: RchPayActivations,
              meta: {
                label: 'RCH Pay activations',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
              }
            },
            {
              path: 'sumup',
              name: 'SumUp activations',
              component: SumUpActivations,
              meta: {
                label: 'SumUp activations',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it', 'mkt_de', 'mkt_ch'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
              }
            },
            {
              path: 'satispay',
              name: 'Satispay activations',
              component: SatispayActivations,
              meta: {
                label: 'Satispay activations',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
              }
            }
          ]
        },
      {
        path: 'mdm-passwords',
        name: 'MDM Passwords',
        component: MdmPasswords,
        meta: {
          label: 'MDM Passwords',
          previous: 'Home',
          icon: null,
          hiddenFor: ['unknown','gcs_unchecked','no_active_account']
        }
      },
        {
            // will match everything
            path: '*',
            redirect: { name: 'Dashboard' },
        },
    ]
}
];

export default routes;
